import { SubmitBookingParamsI } from './Ticket';

export interface SubmitBookingPreviewResI {
  bookingPreviews: BookingPreviews;
  shineStatus: unknown[];
}
export interface EachPreviewedMergedFile {
  driveFileId: string;
  filename: string;
  mimeType: string;
  size: number;
  url: string;
  webViewLink: string;
  _filename: string;
}
export type PreviewedMergedFiles = EachPreviewedMergedFile[];
export interface BookingPreviews {
  [bookingNo: string]: PreviewedMergedFiles;
}

class BookingPreviewsHelper {
  static getPreviewResultAtFileIndexAtBookingNo(
    previewResult: BookingPreviews,
    fileIndex,
    bookingNo,
  ): EachPreviewedMergedFile {
    const previewFilesAtBooking =
      (bookingNo && previewResult[bookingNo]) ?? [];
    const previewFilesAtBookingN = previewFilesAtBooking.length;
    if (fileIndex >= previewFilesAtBookingN) {
      throw Error(
        `index out of bound ${fileIndex}. previewFilesAtBooking length ${previewFilesAtBookingN}`,
      );
    }
    return previewFilesAtBooking[fileIndex];
  }
  /**
   * calculate updated previewResult
   * @param preCutPreviewParamsSubmitted parameters that should match updated previewResult
   * @param changedOnlyPreviewResult
   */
  static getUpdatedPreviewResult(
    previousPreviewResult: BookingPreviews,
    preCutPreviewParamsSubmitted: SubmitBookingParamsI,
    changedOnlyPreviewResult: BookingPreviews,
  ): BookingPreviews {
    const bookingsParamsSubmitted =
      preCutPreviewParamsSubmitted.bookings;
    const oldBookingNoToMergedFiles = previousPreviewResult ?? {};
    const newBookingNoToMergedFiles = changedOnlyPreviewResult ?? {};
    return bookingsParamsSubmitted.reduce((acc, bookingParams) => {
      const { bookingNo } = bookingParams;
      const filesMapToUse =
        bookingNo in newBookingNoToMergedFiles
          ? newBookingNoToMergedFiles
          : oldBookingNoToMergedFiles;
      const mergedFiles = filesMapToUse[bookingNo];
      if (mergedFiles) acc[bookingNo] = mergedFiles;
      return acc;
    }, {});
  }
}

export { BookingPreviewsHelper };
